import React from 'react';

const Notice = () => {
    return (
        <div className='my-28 p-8'>
            <h3 className='text-xl font-bold'>সবুজের সমারোহে গড়ে ওঠা আপনাদের পরিচিত  সুনামধন্য দ্বীনি শিক্ষা প্রতিষ্ঠান মাদরাসা-এ জালালুদ্দীন রুমী এর সকল বিভাগে ভর্তি চলিতেছে।</h3>
            <h4 className='font-semibold text-left mt-4'>বিভাগ সমূহঃ</h4>
            <p className='text-justify'>
                নূরানী মক্তব।বিশুদ্ধ নাজেরা।হেফজজুল কোরআন ও কিতাব বিভাগের প্রথম দুই জামাত  তথা খূসুসী ও তাইসীর জামাতে ভর্তি চলিতেছে।
                মনে রাখাবেন! মাদরাসা-এ জালালুদ্দীন রুমী সবুজ শ্যামল ও দখিনা হাওয়ার মনমুগ্ধকর নিরিবিলি পরিবেশে তালীম ও তরবিয়াতের সমন্বয়ে গড়ে ওঠা  এক খালেছ দ্বীনি শিক্ষা প্রতিষ্ঠান।
                যেখানে আপনার সন্তানকে আদর্শবান মানুষ হিসাবে গড়ে তোলার লক্ষ্যে লেখা পড়ার সাথে সাথে আমলি জীবন তৈরীর পূর্ণাঙ্গ ফিকির করা হয়।
                বিশেষ দ্রষ্টব্যঃ মেধাবী.এতিম.গরিব.ও অসহায় ছাএদের জন্য বিশেষ সুযোগ রয়েছে।</p>
            <h4 className='font-semibold text-left mt-4'>যাতায়াতঃ</h4>
            <address className='text-left'>
                ১।জয়পাড়া কলেজ মোড় ও দোহার বাজার হতে নিকড়া গার্মেন্টসের সামনে রুমী নগর।<br />
                ২।নবাবগঞ্জ দিঘির পাড় হতে খামার বাড়ীর সামনে রুমী নগর। <br />
                যোগাযোগ নাম্বারঃ 01758053022 <br />
                মুফতি মুহাম্মদ শফী প্রিন্সিপাল অত্র মাদ্রাসা।
            </address>



        </div>
    );
};

export default Notice;